interface Properties {
  name: string;
  timeout: number;
}

export function waitForCookie({
  name,
  timeout,
}: Properties): Promise<string | null> {
  return new Promise<null | string>((resolve) => {
    const t0 = performance.now();
    const loopInterval = setInterval(detectCookie, 200);

    /**
     * Function to detect cookie inside the interval
     */
    function detectCookie() {
      const t1 = performance.now();
      if (t1 - t0 <= timeout) {
        const cookie = document.cookie
          .split('; ')
          .find((row) => row.startsWith(name));
        if (cookie) {
          clearInterval(loopInterval);
          resolve(cookie.split('=')[1]);
        }
      } else {
        clearInterval(loopInterval);
        resolve(null);
      }
    }
  });
}
